<template>
  <v-container fluid grid-list-md>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap align-center>
        <v-flex d-flex xs12 sm12 pa-2>


        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>

export default {
  name: 'Vacation',
  data: () => ({
  }),

  props: {
  },

  methods: {
  }
}
</script>
